import React, { Component } from 'react';

import { Container, Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { Chart } from 'react-google-charts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import connect from 'react-redux/es/connect/connect';
import AnnouncementModal from '@components/Elements/AnnouncementModal/AnnouncementModal';
import axiosInstance from '@src/axios-instance';
import moment from 'moment';
import { Link } from 'react-router-dom';

const links = [
  {
    text: 'Farmers Dashboard',
    link: 'https://eagent.farmersinsurance.com'
  },
  {
    text: 'Google',
    link: 'https://www.google.com/'
  },
  {
    text: 'GIG Insurance',
    link: 'http://www.gigins.com'
  },
  {
    text: 'Kevin Davis Insurance',
    link: 'http://www.kdisonline.com'
  },
  {
    text: 'AM Best Rating',
    link: 'http://www.ambest.com'
  },
  {
    text: 'Secretary of State Lookup',
    link: 'https://www.sos.ca.gov/business-programs/business-entities/'
  },
  {
    text: 'Monday.com',
    link: 'https://www.monday.com/'
  },
  {
    text: 'Quickbooks Online',
    link: 'https://quickbooks.intuit.com/online/'
  },
  {
    text: 'Google Maps',
    link: 'https://www.google.com/maps'
  },
  {
    text: 'PMA',
    link: 'http://www.mgalive.com'
  },
  {
    text: 'McGowan Programs',
    link: 'http://www.mcgowanprograms.com'
  },
  {
    text: 'Personal Umbrella',
    link: 'http://www.personalumbrella.com'
  }
];

/*const documents = [
  {
    text: 'Accord 27 Mannual',
    link:
      'https://rpi-dev.s3-us-west-2.amazonaws.com/This+is+a+sample+file+for+RPI+Hub.pdf'
  },
  {
    text: 'Farmers Help Document',
    link:
      'https://rpi-dev.s3-us-west-2.amazonaws.com/This+is+a+sample+file+for+RPI+Hub.pdf'
  },
  {
    text: 'Loaner Code',
    link:
      'https://rpi-dev.s3-us-west-2.amazonaws.com/This+is+a+sample+file+for+RPI+Hub.pdf'
  },
  {
    text: 'Carrier Reference List',
    link:
      'https://rpi-dev.s3-us-west-2.amazonaws.com/This+is+a+sample+file+for+RPI+Hub.pdf'
  },
  {
    text: 'Umbrella Liability Mannual',
    link:
      'https://rpi-dev.s3-us-west-2.amazonaws.com/This+is+a+sample+file+for+RPI+Hub.pdf'
  },
  {
    text: 'Property Coverage Q&A',
    link:
      'https://rpi-dev.s3-us-west-2.amazonaws.com/This+is+a+sample+file+for+RPI+Hub.pdf'
  }
];*/

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.toggleModal = this.toggleModal.bind(this);
    this.state = {
      annoucementModalActive: false,
      announcements: [],
      eois: [],
      keys: []
    };
    this.loadAnnouncements();
    this.loadDiagram();
  }

  loadAnnouncements = () => {
    axiosInstance()
      .post('/announcements/dashboard.json')
      .then(response => {
        this.setState({
          announcements: response.data
        });
      })
      .catch(err => {});
  };

  loadDiagram = () => {
    axiosInstance()
      .post('/evidence-of-insurances/dashboard.json')
      .then(response => {
        this.setState({
          eois: response.data.result,
          keys: response.data.keys
        });
      })
      .catch(err => {});
  };

  toggleModal = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  render = () => {
    return (
      <React.Fragment>
        <Container className={'test'}>
          <Row>
            <Col>
              <Card className={'h-100'}>
                <CardHeader>
                  Announcements
                  <Link to={'/announcements'} className={'float-right'}>
                    View More
                  </Link>
                  {this.props.role === 'ADMIN' && (
                    <FontAwesomeIcon
                      icon={['fas', 'comment-medical']}
                      className={'color-blue float-right mr-2 pointer'}
                      onClick={() => this.toggleModal('annoucementModalActive')}
                    />
                  )}
                </CardHeader>
                <CardBody
                  style={{
                    padding: '0.9rem',
                    overflowY: 'auto',
                    height: '300px'
                  }}
                >
                  {this.state.announcements.length === 0 && (
                    <div className={'pb-3 color-menu-blue'}>
                      Notifications list empty.
                    </div>
                  )}
                  {this.state.announcements.map((item, index) => {
                    const createdDate = moment(item.created * 1000).format(
                      'ddd, MM/DD/YYYY hh:mm A'
                    );
                    const modifiedDate = moment(item.modified * 1000).format(
                      'ddd, MM/DD/YYYY hh:mm A'
                    );
                    return (
                      <div className={'pb-3'} key={'announcement-' + index}>
                        <div className={'font-xs color-menu-blue'}>
                          {item.created === item.modified ? (
                            <span>
                              {createdDate} by {item.user.name}
                            </span>
                          ) : (
                            <span>
                              {modifiedDate} modified by{' '}
                              {item.updated_user.name}
                            </span>
                          )}
                          {'. '}
                          {item.user.id !== item.updated_user.id && (
                            <span>
                              Original annoucement created by {item.user.name}{' '}
                              on {createdDate}.
                            </span>
                          )}
                        </div>
                        <div
                          className={'font-sm'}
                          style={{
                            lineHeight: '18px',
                            wordBreak: 'break-word'
                          }}
                        >
                          {item.body}
                        </div>
                      </div>
                    );
                  })}
                  {/*<div className={'pb-3'}>
                  <div className={'font-xs color-menu-blue'}>
                    Wed, 05/29/2019 02:05 PM by Jon Snow
                  </div>
                  <div className={'font-mid'}>
                    Look out for new association added. Ocean Breeze Homeowners
                    Association. New account from this month.
                  </div>
                </div>
                <div className={'pb-3'}>
                  <div className={'font-xs color-menu-blue'}>
                    Wed, 05/29/2019 02:05 PM by Jon Snow
                  </div>
                  <div className={'font-mid'}>
                    Bagels and donuts in the conference room, please help
                    yourself and enjoy! Won't last long!
                  </div>
                </div>
                <div className={'pb-3'}>
                  <div className={'font-xs color-menu-blue'}>
                    Wed, 05/29/2019 02:05 PM by Jon Snow
                  </div>
                  <div className={'font-mid'}>
                    Please make sure to follow new Accord 27 Mannual. Find it in
                    Userful Documents section on your beautiful, new dashboard!
                  </div>
                </div>*/}
                </CardBody>
              </Card>
            </Col>
            <Col>
              <Card className={'h-10'}>
                <CardHeader>
                  EOIs Delivered
                  <Link className={'float-right'} to={'/eoi-statistics'}>
                    View Details
                  </Link>
                </CardHeader>
                <CardBody>
                  <div className={'my-pretty-chart-container'}>
                    {/*<Chart
                      chartType="AreaChart"
                      loader={<div>Loading Chart</div>}
                      data={[
                        ['', 'Wins', 'Losses'],
                        ['Jan 2019', 0, 0],
                        ['Feb', 0, 0],
                        ['Mar', 0, 0],
                        ['Apr', 0, 0],
                        ['May', 0, 0]
                      ]}
                      options={{
                        hAxis: { title: '', titleTextStyle: { color: '#333' } },
                        vAxis: { minValue: 0 },
                        chartArea: { width: '90%', height: '80%' },
                        legend: { position: 'bottom' }
                      }}
                      width="100%"
                      height="300px"
                    /> */}
                    {this.state.eois.length > 0 && (
                      <Chart
                        width={'100%'}
                        height={'300px'}
                        chartType="LineChart"
                        loader={<div>Loading Chart</div>}
                        data={[
                          [
                            { type: 'string', label: 'Day' },
                            { type: 'number', label: 'Total EOIs' },
                            { type: 'number', label: 'Purchases' },
                            { type: 'number', label: 'Refinances' },
                            { type: 'number', label: 'Renewal' },
                            { type: 'number', label: 'B2B (Billable)' },
                            { type: 'number', label: 'B2B ($0 Fee)' }
                          ],
                          ...this.state.eois
                        ]}
                        options={{
                          legend: { position: 'top' },
                          chartArea: { width: '80%', height: '80%' },
                          hAxis: { title: 'Date' },
                          vAxis: { title: 'EOIs Delivered', format: '0' },
                          colors: [
                            '#3b5249',
                            '#00b7c2',
                            '#fddb3a',
                            '#ff5959',
                            '#9c9427',
                            '#05e386'
                          ],
                          lineWidth: 3
                        }}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className={'mt-4'}>
            <Col>
              <Card className={'h-100'}>
                <CardHeader>Helpful Links</CardHeader>
                <CardBody>
                  <Row className={'links-section'}>
                    {links.map(item => {
                      return (
                        <Col key={item.text} className={'col-6'}>
                          <a
                            href={item.link}
                            target={'_blank'}
                            className={'color-text-grey py-1 d-block'}
                          >
                            {item.text}
                          </a>
                        </Col>
                      );
                    })}
                  </Row>
                </CardBody>
              </Card>
            </Col>
            {/*<Col>
            <Card className={'h-100'}>
              <CardHeader>Userful Documents</CardHeader>
              <CardBody>
                <Row>
                  {documents.map(item => {
                    return (
                      <Col key={item.text} className={'col-6 mb-2'}>
                        <a
                          href={item.link}
                          target={'_blank'}
                          className={'color-text-grey py-1 d-flex flex-column'}
                        >
                          <FontAwesomeIcon
                            icon={['fas', 'file-alt']}
                            className={'font-lg color-blue'}
                          />
                          {item.text}
                        </a>
                      </Col>
                    );
                  })}
                </Row>
              </CardBody>
            </Card>
          </Col>*/}
          </Row>
        </Container>
        {this.state.annoucementModalActive && (
          <AnnouncementModal
            entity={{}}
            toggle={() => this.toggleModal('annoucementModalActive')}
            isActive={this.state.annoucementModalActive}
            callback={this.loadAnnouncements}
          />
        )}
      </React.Fragment>
    );
  };
}
const mapStateToProps = state => {
  return {
    role: state.auth.role
  };
};
export default connect(
  mapStateToProps,
  null
)(Dashboard);
